// Formato di username e password accettato dal login (validazione lato form).
export const USER_REGEX = /^[A-Za-z][.A-Za-z0-9-_]{3,15}$/i;
export const PWD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@$%^&*()+=]).{6,20}$/;
